import React, { useContext } from 'react';

const GrantedPrivilegesContext = React.createContext<string[]>([]);

export default GrantedPrivilegesContext;

/**
 * Returns the granted privileges for the current entity page.
 * These are fetched once by EntityPage and stored in context,
 * so any component in the tree can read them without extra queries.
 */
export const useGrantedPrivileges = (): string[] => {
    return useContext(GrantedPrivilegesContext);
};
